<template>
	<AccountLogin :data="brandData" v-if="!isHW()" />
	<HwLogin v-else :data="brandData" />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import AccountLogin from './component/account/AccountLogin.vue'
import HwLogin from './component/account/HwLogin.vue'
import { getBrand } from '/@/api/common'
import type { BrandDate } from '@/api/types/common'
import { setThem } from '/@/utils/theme'
import { useStore } from '/@/store'
import { i18n } from '/@/i18n'
import { Local } from '/@/utils/storage'
import { onMounted } from 'vue'
import { isHW } from '/@/utils'

const { t } = i18n.global
//获取品牌信息
const url = ref(process.env.NODE_ENV === 'development' ? 'account-test.oemsaas.cn' : location.host)
const brandData = ref<BrandDate>({} as BrandDate)
const store = useStore()
const getBrandInfo = async () => {
	const { data } = await getBrand(url.value)
	document.title = `${t('login.login')} - ${data?.brand_name}`
	Local.set('account-font-platInfo', data)
	store.dispatch('platForm/setPlatInfos', data)
	brandData.value = data as unknown as BrandDate
	setThem() //设置全局主题
}
onMounted(getBrandInfo)
</script>

<style scoped lang="scss"></style>
